import { useParams, Link } from 'react-router-dom';
import { categories, categoriesMap } from '@/mocks/categories';
import { getVideosByCategory } from '@/mocks/videos';
import VideoCard from '@/components/base/VideoCard';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = slug ? categoriesMap[slug] : undefined;
  const categoryVideos = slug ? getVideosByCategory(slug) : [];

  return (
    <div className="pt-24 pb-12 md:pb-16 min-h-screen">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap">
          <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line text-xs"></i>
          <span className="text-foreground-800 font-medium">
            {currentCategory ? currentCategory.name : '分类'}
          </span>
        </nav>

        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
          {currentCategory ? currentCategory.name : '全部分类'}
        </h1>
        <p className="text-sm text-foreground-500 mb-8">
          {currentCategory ? currentCategory.description : '浏览所有视频分类'}
        </p>

        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-all whitespace-nowrap ${
                slug === cat.id
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 border border-background-200/70'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        {categoryVideos.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {categoryVideos.map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
              <i className="ri-film-line text-2xl text-foreground-400"></i>
            </div>
            <p className="text-foreground-500">该分类暂无内容</p>
          </div>
        )}
      </div>
    </div>
  );
}